


<section id="lucky" class="aol">
  <div class="container mt-md-5 pt-md-5">
    <div class="row">

      <div class="col-md-12 text-center">
        <h3>
          PREVENTA CON EL 10%
        </h3>
        <p>
            APARTA TU folio con $450 PESOS y participa todo el 2026
        </p>
      </div>


      <div class="col-xl-6 col-md-12">

        <div class="content-machine">
          <div class="text-center">
            <img src="/assets/img/sorteo2025/magno.png" alt="Sorteo Anáhuac MAgno" class="img-fluid">
          </div>

          <div class="numbers-container">

            <div class="numbers btn-gradient">
              <ul id="list-n0">
                <li>0</li>
                <li>1</li>
                <li>2</li>
                <li>3</li>
                <li>4</li>
                <li>5</li>
                <li>6</li>
                <li>7</li>
                <li>8</li>
                <li>9</li>
                <li>0</li>
                <li>1</li>
                <li>2</li>
                <li>3</li>
                <li>4</li>
                <li>5</li>
                <li>6</li>
                <li>7</li>
                <li>8</li>
                <li>9</li>

              </ul>
            </div>
            <div class="numbers btn-gradient">
              <ul id="list-n1">
                <li>0</li>
                <li>1</li>
                <li>2</li>
                <li>3</li>
                <li>4</li>
                <li>5</li>
                <li>6</li>
                <li>7</li>
                <li>8</li>
                <li>9</li>
                <li>0</li>
                <li>1</li>
                <li>2</li>
                <li>3</li>
                <li>4</li>
                <li>5</li>
                <li>6</li>
                <li>7</li>
                <li>8</li>
                <li>9</li>


              </ul>
            </div>
            <div class="numbers btn-gradient">
              <ul id="list-n2">
                <li>0</li>
                <li>1</li>
                <li>2</li>
                <li>3</li>
                <li>4</li>
                <li>5</li>
                <li>6</li>
                <li>7</li>
                <li>8</li>
                <li>9</li>
                <li>0</li>
                <li>1</li>
                <li>2</li>
                <li>3</li>
                <li>4</li>
                <li>5</li>
                <li>6</li>
                <li>7</li>
                <li>8</li>
                <li>9</li>


              </ul>
            </div>

            <div class="numbers btn-gradient">
              <ul id="list-n3">
                <li>0</li>
                <li>1</li>
                <li>2</li>
                <li>3</li>
                <li>4</li>
                <li>5</li>
                <li>6</li>
                <li>7</li>
                <li>8</li>
                <li>9</li>
                <li>0</li>
                <li>1</li>
                <li>2</li>
                <li>3</li>
                <li>4</li>
                <li>5</li>
                <li>6</li>
                <li>7</li>
                <li>8</li>
                <li>9</li>


              </ul>
            </div>

            <div class="numbers btn-gradient">
              <ul id="list-n4">
                <li>0</li>
                <li>1</li>
                <li>2</li>
                <li>3</li>
                <li>4</li>
                <li>5</li>
                <li>6</li>
                <li>7</li>
                <li>8</li>
                <li>9</li>
                <li>0</li>
                <li>1</li>
                <li>2</li>
                <li>3</li>
                <li>4</li>
                <li>5</li>
                <li>6</li>
                <li>7</li>
                <li>8</li>
                <li>9</li>


              </ul>
            </div>

            <div class="numbers btn-gradient">
              <ul id="list-n5">
                <li>0</li>
                <li>1</li>
                <li>2</li>
                <li>3</li>
                <li>4</li>
                <li>5</li>
                <li>6</li>
                <li>7</li>
                <li>8</li>
                <li>9</li>
                <li>0</li>
                <li>1</li>
                <li>2</li>
                <li>3</li>
                <li>4</li>
                <li>5</li>
                <li>6</li>
                <li>7</li>
                <li>8</li>
                <li>9</li>


              </ul>
            </div>

          </div>

          <div class="content text-center">

            <a *ngIf="!flag_buy" (click)="getBoletoRandom();" class="btn-stack generate-number  mx-auto">

              Activar
            </a>
            <div *ngIf="flag_buy_loader" class="w-100 text-center mt-3">
              <p class="paragraph">
                Generando tu número...
              </p>
              <!-- <div class="lds-hourglass"></div> -->
              <img src="/assets/img/sorteo2025/tickets.gif" class="img-fluid gif-ticket" width="170">

            </div>

            <button *ngIf="flag_buy_btn" class="btn-stack btn-search mt-4" (click)="efectuarPago()"
              [disabled]="botonDisabled">
              Agregar a Carrito
            </button>

            <div id="Msg" [hidden]="true" class="alert alert-info mostrar text-center">
              Por el momento no contamos con boletos disponibles
            </div>
            <!-- Mensaje de error: Cuando no está disponible el boletos consultado -->
            <div *ngIf="boleto_disponible == 0" class="alert alert-info mostrar text-center">
              El boleto ya no se encuentra disponible, favor de escoger otro
            </div>

            

          </div>


        </div>


      </div>

      <div class="col-xl-6 col-md-12  pt-xl-0 pt-4 text-center my-auto">
        <div class="content-head">
          <h4>FECHA <span>DEL</span> SORTEO</h4>
          <p>  <span class="h-100 my-auto"></span> nov <span>.</span> 2026</p>

          <p class="cost"> COSTO<strong> folio preventa </strong> </p>

         
          <div class="row">

            <div class="col-md-6">
              <span class="d-block">Precio normal</span>
              <span class="price mt-2  d-inline-block" style=" text-decoration: line-through;color: #999;">
                $500
              </span>
            </div>

            <div class="col-md-6">
              <span class="d-block">Precio con descuento</span>
              <span class="price mt-2 d-inline-block">
                $450
              </span>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</section>



<section id="stc-inputs">
  <div class="container">
    <div class="row container-input">
      <div class="col-md-12">
        <h3 class="text-center">
          o selecciona tus boletos por:
        </h3>
      </div>

      <div class="col-md-12">
        <div class="row inside">
          <!-- input 1 -->
          <div class="col-md-4 offset-2">
            <label for="busq-three" class="">
              Boletos que inicien en:
              <input type="radio" id="busq-three" name="options" (click)="inputDisabled(3)"
                [checked]="!inputDisabled_3" />
            </label>
          </div>
          <div class="col-md-4">
            <input type="tel" class="input-box" placeholder=" _ _ " maxlength="2" [(ngModel)]="option_3"
              [disabled]="inputDisabled_3" />
          </div>

          <!-- input 2 -->
          <div class="col-md-4 offset-2">
            <label for="busq-one" class="">
              Boletos que terminen en:
              <input type="radio" id="busq-one" name="options" (click)="inputDisabled(1)"
                [checked]="!inputDisabled_1" />

            </label>
          </div>

          <div class="col-md-4">
            <input type="tel" class="input-box" placeholder=" _ _ " maxlength="2" [(ngModel)]="option_1"
              [disabled]="inputDisabled_1" />
          </div>

          <!-- input 3 -->
          <div class="col-md-4 offset-2">
            <label for="busq-two" class="">
              Boletos que contengan los dígitos:
              <input type="radio" id="busq-two" name="options" (click)="inputDisabled(2)"
                [checked]="!inputDisabled_2" />

            </label>
          </div>
          <div class="col-md-4">
            <input type="tel" class="input-box" placeholder=" _ _ " maxlength="2" [(ngModel)]="option_2"
              [disabled]="inputDisabled_2" />
          </div>

          <!-- input 4 -->

          <div class="col-md-4 offset-2">
            <label for="busq-four" class="">
              ¿Buscas tu número de la suerte?
              <span class="d-md-block">(teclea aquí)</span>
              <input type="radio" id="busq-four" name="options" (click)="inputDisabled(4)"
                [checked]="!inputDisabled_4" />

            </label>
          </div>
          <div class="col-md-4">
            <!-- Validar el minimo de caracteres -->
            <input type="tel" class="input-box" placeholder=" _ _ _ _ _ _ " maxlength="6" [(ngModel)]="option_4"
              [disabled]="inputDisabled_4" />
          </div>



        </div>
      </div>

      <div class="col-12 col-md-6 text-center"
        *ngIf="option_1 ? true : option_2 ? true : option_3 ? true : option_4 ? true : false">
        <button class="btn-action btn-stack btn-search" (click)="getLuckyBoleto(option_1, option_2, option_3, option_4)"
          data-toggle="modal" data-target="#modalBoletos">
          Buscar boleto <i class="fa fa-search" aria-hidden="true"></i>
        </button>
      </div>

      <div class="col-12 col-md-6 text-center">
        <button class=" btn-stack" (click)="efectuarPago()" [disabled]="botonDisabled">
          Agregar a Carrito
          <i class="fa fa-shopping-cart" aria-hidden="true"></i>
        </button>
      </div>

      <div class="col-12 col-md-6 text-center" *ngIf="boleto_.length > 0">
        <button id="item" class="btn-action btn-stack" (click)="efectuarPago()" visibility="hidden">
          Pagar <i class="fa fa-money" aria-hidden="true"></i>
        </button>
      </div>




    </div>
  </div>
</section>


<!-- Modal -->
<div class="modal fade" id="modalBoletos" tabindex="-1" role="dialog" aria-labelledby="modalBoletosCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Boletos generados</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body text-center">
        <div class="row" id="ListBol" [hidden]="true">

          <div [class.mostrar]="Error === true" [class.ocultar]="Error === false"
            class="text-danger col-12 text-center">
            <h4>
              {{ mensajeError }}
            </h4>
          </div>

          <div [class.mostrar]="ErrorSuerte === true" [class.ocultar]="ErrorSuerte === false"
            class="text-danger col-12 text-center">
            <h4>
              En este Sorteo el boleto no está disponible
              ¿deseas que te lo reservemos para el próximo Sorteo?
            </h4>
            <button class="btn-action btn-stack d-block border-0 text-center mx-auto mt-4"
              (click)="Registrobol(option_4)">
              Reservar boleto
            </button>
          </div>



          <div *ngFor="let boleto of boletos" class="col-lg-3 col-md-4 col-6">
            <label class="" *ngIf="boleto.folio">
              <input name="boletos-seleccionados" type="checkbox" [(ngModel)]="boleto.marcado"
                value="{{ boleto.folio }}" (change)="btnable(boleto.marcado)" />

              {{ boleto.folio }}
              <span class="checkmark chec"></span>
            </label>
          </div>

        </div>


      </div>
      <div class="modal-footer">
        <button type="button" class="btn-stack" data-dismiss="modal">
          Cerrar
        </button>
        <button class="btn-action btn-stack" (click)="efectuarPago()" [disabled]="botonDisabled"
          data-dismiss="modal">Agregar a Carrito</button>
      </div>
    </div>
  </div>
</div>
